import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ProjectViewModel } from '../../../models-views/project.view.model';
import { AppCommon } from '../../../providers/app-common';
import { TaskViewModel } from '../../../models-views/task.view.model';

interface ItemData {
  name: string;
  link: string;
  createdAt: Date;
  createdBy: string;
  id: number; // Optional: for identifying items for removal
} 


@Component({
  selector: 'app-cpd-drive-links',
  standalone: false,
  templateUrl: './cpd-drive-links.component.html',
  styleUrl: './cpd-drive-links.component.scss'
})
export class CpdDriveLinksComponent {

  isVisibleAddLink:boolean
  @Input() projectLinks:any[] = []
  @Input() project:any 
  loggedInUser:any
  listOfUser:any[] = []
  @Output() linksChanged = new EventEmitter<any>();

  constructor(private message: NzMessageService,
    private cdr: ChangeDetectorRef, 
     private vm : ProjectViewModel,private vmt:TaskViewModel) { 
    this.loggedInUser = AppCommon.getloggedInObject().user
    this.vmt.userList.subscribe( e => this.listOfUser = e.results )
    this.vmt.getUserList(1,100);
    this.vm.parentCpdDriveLinksComponent = this;
  }

  ngOnChanges(changes:SimpleChanges):void {
    if(changes['project'].currentValue ){
      // console.log(changes['project'].currentValue)
      this.cdr.detectChanges();
      // console.log(changes['project'].currentValue)
    }
  }

  removeRow(id: number){
    this.projectLinks = this.projectLinks.filter((item) => item.id !== id);
    this.message.success(`Item with ID ${id} removed`);
    this.vm.deleteProjectLink(id);
  }

  linkRemoved(id: number){
    this.linksChanged.emit(true);
    const links = this.project.links.filter(e => e != id);
    let data = this.getPayload(links);
    this.vm.parentCpdDriveLinksComponent = this;
    this.vm.updateProject(data, this.project.id, 'app-cpd-drive-links');
  }

  getUserName(id:number){
    if(this.listOfUser){
        return id ?  this.listOfUser.filter(e => e.id == id)[0]?.name : 'NA'
    } else {
      return 'NA';
    }
  }

  getPayload(links: any[]){
    let payload = {
      links: links,
      modified_by: this.loggedInUser.id,
      id: this.project.id,
    }
    return payload
  }
  
  onLinksChanged(linkIds: any) {
    // this.projectForm.patchValue({ links: linkIds }); 
    // let data = { links: [linkIds.id,...this.project.links] }
    // data['modified_by'] = this.loggedInUser.id;
    // data['name'] = this.project.name;
    // data['project_client'] = this.project.project_client;
    // data['due_date'] = this.project.due_date;
    // data['description'] = this.project.description;
    // console.log(linkIds)
    let data = this.getPayload([linkIds.id,...this.project.links]);
    this.vm.parentCpdDriveLinksComponent = this;
    this.vm.updateProject(data, this.project.id, 'app-cpd-drive-links');
  }

  projectUpdated(){
    this.linksChanged.emit(true);
  }

  setLinkDetails(linkDetails:any) { 
    // this.projectLinks.push(linkDetails) 
    // console.log(linkDetails)
  } 

  openAddLink(){
    this.isVisibleAddLink = true
  }

  closeAddLinkEvent(e:any){
    this.isVisibleAddLink = false
  }
  
}
